/** CampusAssignments stage helpers — tailor app + admin packing share one collection. */

export function normalizeAssignmentStage(stage) {
    return String(stage || "pending").toLowerCase().trim();
}

/** All stages used in Distribution dropdown + filters. */
export const ASSIGNMENT_STAGES = [
    "pending", "cutting", "stitching", "ready", "packed", "received", "box_packed",
];

/** Tailor ne complete kiya — abhi tailor ke paas (uthana baaki). */
export function isTailorPackedStage(stage) {
    return normalizeAssignmentStage(stage) === "packed";
}

/** Uth liya / warehouse received / admin box packed — tailor pipeline complete. */
export function isCollectedOrDoneStage(stage) {
    const st = normalizeAssignmentStage(stage);
    return st === "received" || st === "box_packed";
}

export function isInProgressStage(stage) {
    return !isTailorPackedStage(stage) && !isCollectedOrDoneStage(stage);
}

export function assignmentStageLabel(stage) {
    const st = normalizeAssignmentStage(stage);
    if (st === "box_packed") return "Box packed";
    return st.charAt(0).toUpperCase() + st.slice(1);
}
